import React from 'react';

import { useGraphRef } from 'src/app/graph/hooks/useGraphRef';
import { GraphBehavioralFlags } from 'src/app/graph/variantLayout/graphBehavioralFlags/graphBehavioralFlags';

import { GlobalHeaderGraphContent } from '../../globalHeaderGraphContent/GlobalHeaderGraphContent';
import { GlobalSandboxHeader } from '../../globalSandboxHeader/GlobalSandboxHeader';

export const GlobalGraphHeader = ({
  graphBehavioralFlags,
}: {
  graphBehavioralFlags: GraphBehavioralFlags;
}) => {
  const graphRef = useGraphRef();
  if (graphRef) {
    return <GlobalHeaderGraphContent currentGraphRef={graphRef} />;
  }
  return <GlobalSandboxHeader graphBehavioralFlags={graphBehavioralFlags} />;
};
